import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Space, Card, Typography, message, Row, Col,
  Tag, Tooltip, Popconfirm,
} from 'antd';
import { PlusOutlined, EditOutlined, BuildOutlined, StopOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';

const { Title } = Typography;

const ProjeTanimPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/projeler');
      const arr = Array.isArray(res.data) ? res.data : res.data.data || [];
      setData(arr);
    } catch {
      message.error('Projeler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleToggleAktif = async (record) => {
    try {
      await api.put(`/projeler/${record.id}`, { ...record, aktif: !record.aktif });
      message.success(record.aktif ? 'Proje pasife alındı' : 'Proje aktive edildi');
      fetchData();
    } catch {
      message.error('İşlem başarısız');
    }
  };

  const columns = [
    {
      title: 'Proje Adı',
      dataIndex: 'projeAdi',
      key: 'projeAdi',
      render: (t) => <strong>{t || '-'}</strong>,
    },
    {
      title: 'Firma Adı',
      dataIndex: 'firmaAdi',
      key: 'firmaAdi',
    },
    {
      title: 'İl / İlçe',
      key: 'konum',
      render: (_, r) => `${r.il || '-'} / ${r.ilce || '-'}`,
    },
    {
      title: 'Şablon',
      dataIndex: 'sablonAdi',
      key: 'sablonAdi',
      render: (v) => v ? <Tag color="purple">{v}</Tag> : <Tag color="default">Yok</Tag>,
    },
    {
      title: 'Aktif',
      dataIndex: 'aktif',
      key: 'aktif',
      align: 'center',
      render: (v) => (
        <Tag color={v ? 'green' : 'red'}>{v ? 'Aktif' : 'Pasif'}</Tag>
      ),
    },
    {
      title: 'İşlemler',
      key: 'actions',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title="Düzenle">
            <Button
              type="primary"
              ghost
              size="small"
              icon={<EditOutlined />}
              onClick={() => navigate(`/projeler/${record.id}/duzenle`)}
            />
          </Tooltip>
          <Tooltip title={record.aktif ? 'Pasife Al' : 'Aktive Et'}>
            <Popconfirm
              title={record.aktif ? 'Projeyi pasife almak istiyor musunuz?' : 'Projeyi aktive etmek istiyor musunuz?'}
              onConfirm={() => handleToggleAktif(record)}
              okText="Evet"
              cancelText="Hayır"
            >
              <Button
                size="small"
                danger={record.aktif}
                type={record.aktif ? 'default' : 'primary'}
                icon={<StopOutlined />}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Space>
            <BuildOutlined style={{ fontSize: 20, color: '#1677ff' }} />
            <Title level={4} style={{ margin: 0 }}>Proje Tanımları</Title>
          </Space>
        </Col>
        <Col>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/projeler/yeni')}>
            Yeni Proje
          </Button>
        </Col>
      </Row>

      <Card className="content-card" bodyStyle={{ padding: 0 }}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          bordered
          size="middle"
          pagination={{ pageSize: 15, showTotal: (t) => `Toplam ${t} proje` }}
          locale={{ emptyText: 'Proje bulunamadı' }}
        />
      </Card>
    </div>
  );
};

export default ProjeTanimPage;
